import React, { useEffect, useState } from 'react'
import Slider from 'react-slick'
import { Typography, Box, useTheme, Skeleton } from '@mui/material'
import {
  IMAGE_BASE_PATH_DBRALC,
  ORGANIZATION_ID,
  SUB_ORGANIZATION_ID,
} from '../../Config/Config'
import { fetchData } from '../../Assets/API/apiservices'

const Header_Carousel = () => {
  const [bannersData, setBannersData] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const theme = useTheme()

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
  }
  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000))
      const result = await fetchData(
        `banners?organization_id=${ORGANIZATION_ID}&sub_organization_id=${SUB_ORGANIZATION_ID}`
      )
      const apiBanners = result.rows.map((row) => ({
        id: row.id,
        src: IMAGE_BASE_PATH_DBRALC + row.image_url,
        isFromAPI: true,
      }))
      setBannersData([...apiBanners])
    } catch (err) {
      console.error('Error fetching banners:', err.message)
    } finally {
      setIsLoading(false)
    }
  }

  const getImageStyles = () => ({
    width: '100%',
    height: 'auto',
    aspectRatio: '16 / 6',
    objectFit: 'cover', // Changed from 'cover' to prevent cropping
  })

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        minHeight={getImageStyles().minHeight}
        maxHeight={getImageStyles().maxHeight}
        bgcolor={theme.palette.background.default}
      >
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          animation="wave"
        />
      </Box>
    )
  }

  if (!bannersData.length) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        minHeight={getImageStyles().minHeight}
        maxHeight={getImageStyles().maxHeight}
        bgcolor={theme.palette.background.default}
      >
        <Typography variant="h5" color="textSecondary" textAlign="center">
          🎉 Welcome! Stay tuned for exciting updates! 🎉
        </Typography>
      </Box>
    )
  }

  return (
    <section>
      <Slider {...settings}>
        {bannersData.map((banner) => (
          <div key={banner.id} style={{ width: '100%', textAlign: 'center' }}>
            <img
              src={banner.src}
              style={getImageStyles()}
              className="blurred-image"
              alt={`banner-${banner.id}`}
              loading="lazy"
              placeholder="blur"
              onLoad={(e) => e.target.classList.remove('blurred-image')}
            />
            <style>
              {`
                .blurred-image {
                  filter: blur(10px);
                  transition: filter 0.5s ease-out;
                }
              `}
            </style>
          </div>
        ))}
      </Slider>
    </section>
  )
}

export default Header_Carousel
